// SPDX-FileCopyrightText: 2026 Z-Meet contributors
// SPDX-License-Identifier: Apache-2.0

import { useEffect, useState } from 'react'
import { CheckCircle, XCircle } from '@phosphor-icons/react'
import { useI18n } from '../i18n'
import * as api from '../api'

/**
 * Đích của link trong thư.
 *
 * ⚠️ Trang này POST, nó KHÔNG dựa vào một GET có tác dụng phụ (ADR-0005 §6).
 * Bộ quét liên kết của nhiều dịch vụ email tự tải trước mọi URL trong thư; với
 * một GET tiêu thụ token thì phiếu bị dùng hết TRƯỚC KHI người thật bấm vào, và
 * triệu chứng là "link của tôi luôn báo hết hạn" — gần như không lần ra được.
 *
 * Token đã được router lấy khỏi fragment và xoá khỏi thanh địa chỉ.
 */
export function Verify({ token, invite = false }: { token: string; invite?: boolean }) {
  const { t } = useI18n()
  const [state, setState] = useState<'working' | 'ok' | 'failed'>('working')
  const [text, setText] = useState('')

  useEffect(() => {
    if (invite) {
      // Nhận lời mời cần đăng nhập, và luồng đó chưa có màn hình riêng ở bản
      // này. Nói thẳng thay vì hiện một vòng quay không bao giờ dừng.
      setState('failed')
      setText(t('ui.invite.sign_in_first'))
      return
    }
    if (!token) {
      setState('failed')
      setText(t('ui.verify.failed'))
      return
    }
    void api.verifyEmail(token).then((r) => {
      setState(r.ok ? 'ok' : 'failed')
      setText(r.ok ? t('ui.verify.done', { email: r.data.email }) : r.message)
    })
  }, [token, invite, t])

  return (
    <main className="center">
      <div className="card">
        <h1>{t(invite ? 'ui.invite.heading' : 'ui.verify.heading')}</h1>
        {state === 'working' ? (
          <p className="sub">…</p>
        ) : (
          <div className={'msg ' + (state === 'ok' ? 'ok' : 'err')}>
            {state === 'ok' ? (
              <CheckCircle size={16} weight="light" />
            ) : (
              <XCircle size={16} weight="light" />
            )}{' '}
            {text}
          </div>
        )}
      </div>
    </main>
  )
}
